import React, { useState } from "react";
import { ChevronRight } from "lucide-react";

const SpectateSection = () => {
    const steps = [
      { title: "Public Spectator View", level: 0, isHeader: true, id: 100 },
      {
        title: "Public Dashboard",
        level: 1,
        parentId: 100,
        image: "/assets/guide/no_auth/spectate_dashboard.png",
        description:
          "View all ongoing public games in real-time without needing to log in.",
      },
      {
        title: "Public Game Board",
        level: 1,
        parentId: 100,
        image: "/assets/guide/no_auth/spectate_game_board.png",
        description:
          "A live, read-only view of a public game session, synchronized via Socket.IO.",
      },
      {
        title: "Authenticated Spectator View",
        level: 0,
        isHeader: true,
        id: 200,
      },
      {
        title: "Auth Dashboard",
        level: 1,
        parentId: 200,
        image:
          "/assets/guide/auth/spectate_live_games/spectate_live_games_dashboard.png",
        description:
          "Access advanced spectator features and view active game sessions.",
      },
      {
        title: "Auth Game Board",
        level: 1,
        parentId: 200,
        image: "/assets/guide/auth/spectate_live_games/spectate_game_board.png",
        description:
          "Enhanced live board view featuring player stats and real-time event updates.",
      },
    ];


  const [stepIndex, setStepIndex] = useState(() => {
    const firstNonHeader = steps.findIndex((step) => !step.isHeader);
    return firstNonHeader !== -1 ? firstNonHeader : 0;
  });

  const [expandedSections, setExpandedSections] = useState({
    100: true,
    200: true,
  });

  const toggleSection = (id) =>
    setExpandedSections((prev) => ({ ...prev, [id]: !prev[id] }));

  const navigate = (direction) => {
    let nextIndex = stepIndex + direction;
    while (nextIndex >= 0 && nextIndex < steps.length) {
      if (!steps[nextIndex].isHeader) {
        setStepIndex(nextIndex);
        return;
      }
      nextIndex += direction;
    }
  };

  const isVisible = (step) =>
    step.level === 0 ? true : expandedSections[step.parentId];
  const currentStep = steps[stepIndex];

  return (
    <div className="guide-layout">
      <nav className="sub-nav">
        {steps.map((step, idx) => {
          const show = isVisible(step);
          const isHeader = !!step.isHeader;
          return (
            <div
              key={idx}
              className={`nav-item-wrapper ${stepIndex === idx ? "active" : ""}`}
              style={{
                maxHeight: show ? "60px" : "0px",
                opacity: show ? 1 : 0,
              }}
            >
              <span
                className={`sub-nav-item level-${step.level} ${isHeader ? "sub-nav-header" : ""}`}
                onClick={() =>
                  isHeader ? toggleSection(step.id) : setStepIndex(idx)
                }
              >
                {isHeader && (
                  <ChevronRight
                    size={16}
                    style={{
                      marginRight: "8px",
                      transform: expandedSections[step.id]
                        ? "rotate(90deg)"
                        : "rotate(0deg)",
                    }}
                  />
                )}
                {step.title}
              </span>
            </div>
          );
        })}
      </nav>

      <main className="guide-main">
        <div className="guide-item">
          <div className="guide-text">
            <h2>{currentStep.title}</h2>
            <div className="nav-controls">
              <button disabled={stepIndex === 0} onClick={() => navigate(-1)}>
                Back
              </button>
              <button
                className="cta-button"
                onClick={() => navigate(1)}
                style={{ marginLeft: "10px" }}
              >
                {stepIndex === steps.length - 1 ? "Finish" : "Next"}
              </button>
            </div>
            {/* Fix 2: Always check for isHeader before accessing properties */}
            {!currentStep.isHeader && (
              <div className="guide-text-wrapper">
                <p className="step-description">{currentStep.description}</p>
              </div>
            )}
          </div>
          {!currentStep.isHeader && (
            <div className="screenshot-container">
              <img src={currentStep.image} alt={currentStep.title} />
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default SpectateSection;
